module.exports = __webpack_public_path__ + "img/9788963190549.6c5b5cc8.jpg";